import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import FeaturedCities from "./components/FeaturedCities";
import ReviewsSection from "./components/ReviewsSection";
import MapBanner from "./components/MapBanner";
import CityGuideLinks from "./components/CityGuideLinks";
import RegionExplorer from "./components/RegionExplorer";
import MonthlyCalendar from "./components/MonthlyCalendar";
import AccommodationCTA from "./components/AccommodationCTA";
import RegionGuideSection from "./components/RegionGuideSection";
import FaqSection from "./components/FaqSection";

const setMeta = (name: string, content: string, isProperty = false) => {
  const attr = isProperty ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (url: string) => {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", url);
};

const injectSchema = (id: string, data: object) => {
  let el = document.getElementById(id);
  if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
  el.textContent = JSON.stringify(data);
};

const HomePage = () => {
  useEffect(() => {
    const title = "Türkiye Seyahat Rehberi — Gezilecek Yerler, Restoranlar ve Şehir Rehberleri";
    const desc = "Türkiye'nin en güzel gezilecek yerleri, en iyi restoranları ve kapsamlı şehir rehberleri. Kapadokya, Efes, Pamukkale, İstanbul ve daha fazlası için Türkiye seyahat rehberi.";
    document.title = title;
    setCanonical("https://geziturkiyem.com/");
    setMeta("description", desc);
    setMeta("keywords", "türkiye gezilecek yerler, türkiye seyahat rehberi, kapadokya, efes, pamukkale, istanbul, gaziantep, karadeniz yaylaları");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", "https://geziturkiyem.com/", true);
    setMeta("og:locale", "tr_TR", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);
    setMeta("last-modified", "2026-04-11");

    injectSchema("schema-webpage", {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": title,
      "description": desc,
      "url": "https://geziturkiyem.com/",
      "inLanguage": "tr-TR",
      "isPartOf": { "@type": "WebSite", "url": "https://geziturkiyem.com" },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" }]
      }
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedCities />
        <RegionGuideSection />
        <RegionExplorer />
        <CityGuideLinks />
        <MonthlyCalendar />
        <ReviewsSection />
        <AccommodationCTA />
        <MapBanner />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
